import { initializeApp } from 'firebase/app'
import { getStorage, ref, uploadBytes as fsUploadBytes, getDownloadURL } from 'firebase/storage'
import { getFirestore } from 'firebase/firestore'
import {
	signOut,
	getAuth,
	signInWithEmailAndPassword as emailAndPassword,
	signInWithCustomToken as signInWithCustomTokenInFirebase,
	GoogleAuthProvider,
	signInWithPopup
} from 'firebase/auth'
import { firebaseConfig } from '../config'

export const firebaseApp = initializeApp(firebaseConfig)
const googleProvider = new GoogleAuthProvider()

// Only allow @scratchpay.com domains to authenticate
googleProvider.setCustomParameters({
	hd: 'scratchpay.com',
	prompt: 'select_account'
})

export const authClient = () => getAuth(firebaseApp)

export const storageClient = getStorage(firebaseApp, `gs://${firebaseConfig.storageBucket}`)

export const signInWithEmailAndPassword = (email, password) =>
	emailAndPassword(authClient(), email, password)

export const signInWithCustomToken = (token: string) =>
	signInWithCustomTokenInFirebase(authClient(), token)

export const logout = () => signOut(authClient())

export const uploadBytes = (location, blob) => uploadBytes(ref(storageClient, location), blob)

export const firestoreClient = () => getFirestore(firebaseApp)

export const uploadFromBlobAsync =
	(rootDirectory: string) =>
	async ({ blobUrl, name }) => {
		if (!blobUrl || !name) return null
		const blob = await fetch(blobUrl).then((r) => r.blob())
		const snapshot = await fsUploadBytes(ref(storageClient, `${rootDirectory}/${name}`), blob)
		return snapshot.ref
	}

export const getDownloadUrl = async (directoryPath) => {
	try {
		const fileRef = ref(storageClient, directoryPath)
		const url = await getDownloadURL(fileRef)
		return url
	} catch (error) {
		console.error('Error getting download URL:', error)
		return null
	}
}

export const signInWithGoogle = async () => signInWithPopup(authClient(), googleProvider)

export const AUTH_USER_NOT_FOUND_ERROR = 'auth/user-not-found'
export const AUTH_WRONG_PASSWORD_ERROR = 'auth/wrong-password'
